import { axiosInstance } from "./axiosInstance";

export const orderService = {
    getOrder: async (filter) => {
        return await axiosInstance.get('/api/superadmin/order', { params: filter })
    },
    addOrder: async (data) => {
        return await axiosInstance.post(`/api/superadmin/order/create-offline`, data)
    },
    exportOrder: async (filter) => {
        return await axiosInstance.get('/api/superadmin/order', { 
            params: { ...filter, is_export: true },
            responseType: 'blob' 
        })
    },
    addTreatment: async (id, data) => {
        return await axiosInstance.post(`/api/superadmin/order/add-treatment/${id}`, data)
    },
    addNote: async (id, data) => {
        return await axiosInstance.post(`/api/superadmin/order/add-cs-notes/${id}`, data)
    },
    changeStatus: async (id, data) => {
        return await axiosInstance.post(`/api/superadmin/order/change-status/${id}`, data)
    },
    reschedule: async (id, data) => {
        return await axiosInstance.post(`/api/superadmin/order/reschedule/${id}`, data)
    },
}